import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import SectionOne from "./Section1";
import OurProducts from "./OurProducts";
import Minds from "./Minds";
import ResponsiveForms from "./ResponsiveForms";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToElement } from "../helper";

function Home() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollToElement = (sectionId) => {
    // Check if the current route is the home page
    if (window.location.pathname === "/") {
      // If on home page, just scroll
      scrollToElement(sectionId);
    } else {
      // If not on the home page, navigate to home and then scroll
      navigate("/");
      setTimeout(() => {
        scrollToElement(sectionId);
      }, 500); // Allow time for the route change before scrolling
    }
  };

  useEffect(() => {
    if (location.hash && location.hash === "#partner-with-us") {
      handleScrollToElement("about-us");
    }
    // eslint-disable-next-line
  }, [location, navigate]);

  return (
    <Stack>
      <SectionOne />
      <OurProducts />
      <Minds />
      <ResponsiveForms />
    </Stack>
  );
}

export default Home;
